import { httpClient } from "@/app/client/httpClient";

class WorkStyleService {
  fetchWorkStyle() {
    return httpClient.accounts.work_style.$get({
      query: { limit: 9999 }
    });
  }
}

export const workStyleService = new WorkStyleService();
